import * as tslib_1 from "tslib";
import styled, { withProps } from '../styles';
var BorderlessSelectIconLayout = withProps()(styled.div)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  right: 0px;\n  top: 0px;\n  bottom: 0px;\n  display: inline-flex;\n  align-items: center;\n  pointer-events: none;\n\n  transform: translateY(-2px);\n\n  ", "\n"], ["\n  position: absolute;\n  right: 0px;\n  top: 0px;\n  bottom: 0px;\n  display: inline-flex;\n  align-items: center;\n  pointer-events: none;\n\n  transform: translateY(-2px);\n\n  ",
    "\n"])), function (props) {
    return !props.syncIconColor &&
        "\n      color: " + (props.error
            ? props.theme.palette.error[500]
            : props.theme.palette.text.secondary) + ";\n    ";
});
export default BorderlessSelectIconLayout;
var templateObject_1;
//# sourceMappingURL=BorderlessSelectIconLayout.js.map